<template>
	<div class="box">
		<div class="row">
			<div class="col-8">
				<template v-if="!loading">
					<Reorganizev2 ref="reorganize" :invoicedetails_id="invoicedetails_ids" :bons="bons" :processing.sync="processing"></Reorganizev2>

					<div class="col-8">
						<b-button block pill variant="primary" @click="onSubmitReorganize"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t("global.sauvegarder") }}</b-button>
					</div>
				</template>
				<template v-else>
					<LoadingSpinner class="col-12" />
				</template>
			</div>
			<div class="col-4">
				<template v-if="change_model_ready">
					<div class="form-group">
						<label for="">{{ $t('invoice.choisir_un_modele_specifique') }}</label>
						<e-select
							v-model="model_choosen"
							id="search_compte"
							track-by="model_label"
							label="model_label"
							:placeholder="getTrad('invoice.choisir_un_modele_specifique')"
							:selectedLabel="getTrad('global.selected_label')"
							:options="model"
							:searchable="true"
							:allow-empty="false"
							:loading="isLoadingModel"
							:show-labels="false"
						>
						</e-select>
					</div>
					<b-button block pill variant="primary" @click="previsualiser" :disabled="!model_choosen"><font-awesome-icon v-if="processing_preview" :icon="['fas', 'spinner']" pulse /> {{ $t("action.previsualiser") }}</b-button>
					<b-button block pill variant="primary" @click="addInvoiceForm" :disabled="!model_choosen"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t("action.facturer") }}</b-button>

				</template>
			</div>
		</div>


		<div class="row mt-5">
			<div class="col">
				<iframe v-if="base64 != null" :src="'data:application/pdf;base64,' + base64" height="1000px" width="100%" style="position:relative"></iframe>
			</div>
		</div>

		<ModalAddInvoice ref="modal" :bons="bons" @submit="invoice_submit" />
	</div>
</template>


<script type="text/javascript">
	import Vue from 'vue'
	import { EventBus } from 'EventBus'


	import TableAction from "@/mixins/TableAction.js"
	import Invoice from "@/mixins/Invoice.js"
	import Accounting from "@/mixins/Accounting.js"

	import Navigation from "@/mixins/Navigation.js"
	import Model from "@/mixins/Model.js"
	import Config from "@/mixins/Config.js"
	import Tiers from "@/mixins/Tiers.js"
	import _uniq from 'lodash/uniq'
	import ContractCleaner from '@/assets/js/cache/cleaners/ContractCleaner'
	import Contract from "@/mixins/Contract.js"

	export default {
		name: "Detailv2",
		mixins: [Config, TableAction, Invoice, Navigation, Accounting, Model, Tiers, Contract],
		props: {
			
		},
		data () {
			return {
				modal_loaded: false,
				loading: false,
				form_message: '',
				send_email: false,
				date: new Date(),
				many_duedate: false,
				params_to_send : [],
				errors : [],
				config_duedate : [],
				amount : {},
				invoicedetails_ids: null,
				change_model: true,
				isLoadingModel: false,
				isLoadingRib: false,
				copy_duedate: null,
				change_rib: false,
				change_model_ready: false,
				change_model_ready_popup: false,
				change_rib_ready: false,
				processing: false,
				model_choosen: null,
				ribs: [],
				model: [],
				base64: null,
				processing_preview: false,
				bons: [],
				events_tab: {
					
				},
				tiers_tab: []
			}
		},
		mounted() {
			this.init_component()
		},
		methods: {
			async init_component() {
				//Split car je passe un tableau au composant reorganize
				this.invoicedetails_ids = this.$route.params.invoicedetails_ids.split(',')
                await this.loadDetails()
				await this.load_model()
			},
			async loadDetails() {
				this.loading = true
				this.has_doublons = false
                this.bons = await this.loadAllBonsv2({
					type: "Invoice",
                	id: this.invoicedetails_ids.join(',')
				})

                this.loading = false
            },
			async load_model(){
				this.change_model_ready = false
				this.change_model_ready_popup = false
				this.isLoadingModel = true
				if(this.bons.length > 0) {
					let result = await this.loadAccountingPlanByEntity(this.bons[0].invoicedetails_author)

					let models = await this.loadAllModel(result.accountingplan_id, ['accounting_plan'])
					models = models.filter(model => (model.type.modeltype_template === 'facture'))

					this.model = models
					this.model_choosen = models.find(model => model.model_default)
				}

				this.isLoadingModel = false
				this.change_model_ready = true
				this.change_model_ready_popup = true
			},
			async onSubmitReorganize() {
				if(!this.processing)
				{
					this.processing = true
					let invoice_details = await this.$refs.reorganize.checkForm()
					if(invoice_details)
					{
						this.successToast()
					}
					this.processing = false
					this.ready = true
				}
			},
			async previsualiser() {
				if(!this.processing_preview)
				{
					this.processing_preview = true
					let infos = []
					infos.push({
						"author_id": this.bons[0].invoicedetails_author,
						"tiers_id": this.bons[0].invoicedetails_tiers,
					})

					let params_to_send = {
						"invoices": infos,
						"invoicedetails_ids": this.invoicedetails_ids.join(','),
						"model": this.model_choosen.model_id
					}

					this.base64 = await this.previewInvoice(params_to_send, false)

					this.processing_preview = false
				}
			},

			addInvoiceForm() {
				this.$refs['modal'].openModal(this.bons.map(i => i.invoicedetails_id))
			},

			invoice_submit() {
				this.$refs['modal'].cancelInvoiceZero()
				this.$router.push({name: 'invoiceList'})
			}
		},
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
			LigneVierge: () => import('@/components/Invoice/LigneVierge'),
			Reorganizev2: () => import('@/components/Invoice/Reorganizev2'),
			ModalAddInvoice: () => import ('@/components/Modals/ModalAddInvoice')
		}
	}
</script>
